import {
  defaultDataIdFromObject,
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory';
import { v4 as uuid } from 'uuid';
import introspectionQueryResultData from './fragmentTypes.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({ introspectionQueryResultData });

export const apolloCache = new InMemoryCache({
  fragmentMatcher,
  // Provide a random id if no id is returned
  dataIdFromObject: (value) => {
    // Provide a random id in order to fix multiple same records
    if (value?.__typename === 'BasicEmailTemplate') {
      return defaultDataIdFromObject({ __typename: value?.__typename, id: uuid() });
    }
    if (
      value?.__typename === 'Booking' ||
      value?.__typename === 'BookingInstallmentPlan' ||
      value?.__typename === 'CustomFieldValue'
    ) {
      return defaultDataIdFromObject({ __typename: value?.__typename, id: value?.id ?? uuid() });
    }
    // Beacause of the bedStatusInfo id isn't unique in occupany chart, we need to provide a special id
    if (value?.__typename === 'BedStatusInfo') {
      return defaultDataIdFromObject({
        __typename: value?.__typename,
        id: value?.bed?.id ? `${value?.id}-${value?.bed?.id}` : value?.id,
      });
    }
    return defaultDataIdFromObject(value);
  },
});
